export default "__VITE_ASSET__DKr9W0z6__"